<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 5%">
                            <CCard class="p-5">
                                <CRow>
                                    <CCol sm="8">
                                        <img style="max-width:100%" src="../assets/img/imgVideo.png" />
                                        <p class="custom-16px-400 text-left mt-5">Interview Date: April 20, 2024</p>
                                        <img style="max-width:100%" src="../assets/img/aivideo.png" />
                                        <h1 class="custom-24px-500 mt-3">
                                            Workmap Score
                                        </h1>
                                        <p class="custom-16px-400 text-left">See the working is one sheet</p>
    
                                        <h4 class="custom-22px-500">Presentation</h4>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">Comets are a big source of meteoroids.</p>
                                            </CCol>
                                            <CCol sm="2">
                                                <p class="custom-16px-400 text-right">70%</p>
                                            </CCol>
                                        </CRow>
    
                                        <img src="../assets/img/progressbar.png" style="max-width:100%" />
    
                                        <h4 class="custom-22px-500">Opportunistic</h4>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">Comets are a big source of meteoroids.</p>
                                            </CCol>
                                            <CCol sm="2">
                                                <p class="custom-16px-400 text-right">70%</p>
                                            </CCol>
                                        </CRow>
    
                                        <img src="../assets/img/progressbar.png" style="max-width:100%" />
    
                                        <h4 class="custom-22px-500">Business Acument</h4>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">Comets are a big source of meteoroids.</p>
                                            </CCol>
                                            <CCol sm="2">
                                                <p class="custom-16px-400 text-right">70%</p>
                                            </CCol>
                                        </CRow>
    
                                        <img src="../assets/img/progressbar.png" style="max-width:100%" />
    
                                        <h4 class="custom-22px-500">Closing Technique</h4>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">Comets are a big source of meteoroids.</p>
                                            </CCol>
                                            <CCol sm="2">
                                                <p class="custom-16px-400 text-right">70%</p>
                                            </CCol>
                                        </CRow>
    
                                        <img src="../assets/img/progressbar.png" style="max-width:100%" />
    
                                        <h4 class="custom-22px-500">Presentation</h4>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">Comets are a big source of meteoroids.</p>
                                            </CCol>
                                            <CCol sm="2">
                                                <p class="custom-16px-400 text-right">70%</p>
                                            </CCol>
                                        </CRow>
    
                                        <img src="../assets/img/progressbar.png" style="max-width:100%" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-24px-500">
                                            At Video Score Detail
                                        </h3>
                                        <CRow>
                                            <CCol sm="6">
                                            <div class="text-center">
                                                <img style="max-width:70%" src="../assets/img/67.png" class="text-center" />
                                                <p class="custom-22px-500 text-center">Attitude</p>
                                            </div>
                                        </CCol>
                                        <CCol sm="6">
                                            <div class="text-center">
                                                <img style="max-width:70%" src="../assets/img/Charts1.png" class="text-center" />
                                                <p class="custom-22px-500 text-center">Socialibility</p>
                                            </div>
                                        </CCol>
    
                                        <CCol sm="6">
                                            <div class="text-center">
                                                <img style="max-width:70%" src="../assets/img/67.png" class="text-center" />
                                                <p class="custom-22px-500 text-center">Communication</p>
                                            </div>
                                        </CCol>
                                        <CCol sm="6">
                                            <div class="text-center">
                                                <img style="max-width:70%" src="../assets/img/Charts1.png" class="text-center" />
                                                <p class="custom-22px-500 text-center">Teamwork</p>
                                            </div>
                                        </CCol>
    
                                            <CCol sm="12">
                                                <h3 class="custom-24px-500 mt-3">User Interview Result: </h3>
                                                <h4 class="custom-18px-600 font-color-171717 mt-4">
                                                    1.Confidence
                                                </h4>
                                                <p>
                                                    <ul>
                                                        <li class="font-color-171717">Clarity: 5/5 - John's response was concise and easy to understand, clearly outlining his strengths and weaknesses as a team player.</li>
                                                        <li class="font-color-171717 mt-2">Confidence: 4/5 - John displayed confidence in discussing his strengths but seemed slightly less assured when addressing his weaknesses.</li>
                                                        <li class="font-color-171717 mt-2">Relevance: 5/5 - John's answer directly addressed the question and provided specific examples to support his points.</li>
                                                    </ul>
    
    
                                                </p>

                                                <h4 class="custom-18px-600 font-color-171717 mt-4">
                                                    2.Confidence
                                                </h4>
                                                <p>
                                                    <ul>
                                                        <li class="font-color-171717">Clarity: 5/5 - John's response was concise and easy to understand, clearly outlining his strengths and weaknesses as a team player.</li>
                                                        <li class="font-color-171717 mt-2">Confidence: 4/5 - John displayed confidence in discussing his strengths but seemed slightly less assured when addressing his weaknesses.</li>
                                                        <li class="font-color-171717 mt-2">Relevance: 5/5 - John's answer directly addressed the question and provided specific examples to support his points.</li>
                                                    </ul>
    
    
                                                </p>
                                                <h4 class="custom-18px-600 font-color-171717 mt-4">
                                                    Overall Assessment:
                                                </h4>
                                                <p class="font-color-171717 mt-2">John provided thoughtful and articulate responses to each interview question, demonstrating a strong understanding of key concepts and principles. While there were minor areas for improvement in terms of confidence and clarity, his responses were generally well-reasoned and relevant to the questions asked.</p>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </div>
                    </CCol>
                </CRow>
            </CCol>

        </CCol>
        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                Sign up now for free and take the first step toward landing your dream job!
                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow


        };
    },
    created() {
        AOS.init();
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>